import fromNullable from "../lib/core/functional/fromNullable";
import { retrieveJsonRequest } from "./utils";

let postIdOrdered;

function getStoredBootstrap() {
    return fromNullable(postIdOrdered);
}

function cacheBootstrap(loadedData) {
    postIdOrdered = loadedData;
    return postIdOrdered;
}

export function fetchSectionPostsOrdered(sectionId) {
    return getStoredBootstrap()
        .catch(() => retrieveJsonRequest(`/core/feeds/site/section_posts_ordered?section_id=${sectionId}&limit=100&offset=0`))
        .then(cacheBootstrap);
}
